import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ProductCategoryService } from '../proxy/general/controllers/product-category.service';
import { ConsumableTypeService } from '../proxy/general/controllers/consumable-type.service';
import { WoodProductDetail } from '@general/wood-product-detail/wood-product-detail';
import { ReasonService } from '../proxy/general/controllers/reason.service';
import { VendorService } from '@controlling/proxy/controlling/controllers';
import { InternalOrderService } from '@controlling/proxy/controlling/controllers';

FieldBuilder.setNamespace('General');

export const FINALPRODUCT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FinalProduct.Name')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.FinalProduct.Code')
    .required()
    .maxLength(20)
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.FinalProduct.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('deactivationReasonId', 'Entity.Person.DeactivationReason', ReasonService)
    .displayFromNested('deactivationReason.name')
    .sortBy('deactivationReason.name')
    .build(),
  FieldBuilder
    .date('deactivationDate', 'Entity.FinalProduct.DeactivationDate')
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.FinalProduct.SapCode')
    .maxLength(20)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('internalOrderId', 'Entity.InternalOrder', InternalOrderService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .text('notes', 'Entity.FinalProduct.Notes')
    .maxLength(300)
    .build(),
  FieldBuilder
    .foreignKey('productCategoryId', 'Entity.ProductCategory', ProductCategoryService)
    .required()
    .displayFromNested('productCategory.name')
    .sortBy('productCategory.name')
    .build(),
];

export const FINALPRODUCT_CONFIG = {
  entityName: 'FinalProduct',
  localizationKey: 'General::Entity.FinalProduct',
  fields: FINALPRODUCT_FIELDS,
  permission: 'GeneralFinalProduct.FinalProducts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.FinalProduct + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'WoodProductDetail',
      foreignKeyField: 'finalProductId',
      localizationKey: 'General::Entity.WoodProductDetail',
      component: WoodProductDetail,
    },
  ]
};
